import React from "react";
import { useNavigate } from "react-router-dom";
import { Table, Button, Tag } from "antd";
import {
  EditOutlined,
  UserAddOutlined,
  WalletOutlined,
} from "@ant-design/icons";
import { PropertyUnits } from "../../Data/Data";

// export const data = {
//   "UNT-001": {
//     tenantName: "A-Tenant 1",
//     propertyName: "Property A",
//     unitName: "A-101",
//     monthlyRent: "UGX 230000",
//     deposit: "UGX 230000",
//     paidThrough: "May 28, 2025",
//     outstanding: "None",
//     phone: "0700123456",
//     status: "Occupied",   
//     payments: [
//       {
//         date: "May 13, 2025",
//         amount: "UGX 230000",
//         coveredFrom: "May 18, 2025",
//         coveredTo: "Jun 17, 2025",
//       },
//     ],
//   },
//   "UNT-002": {
//     tenantName: "B-Tenant 2",
//     propertyName: "Property B",
//     unitName: "B-102",
//     monthlyRent: "UGX 210000",
//     deposit: "UGX 210000",
//     paidThrough: "May 25, 2025",
//     outstanding: "None",
//     phone: "0700234567",
//     status: "Occupied",
//     payments: [
//       {
//         date: "May 10, 2025",
//         amount: "UGX 210000",
//         coveredFrom: "May 15, 2025",
//         coveredTo: "Jun 14, 2025",
//       },
//     ],
//   },
//   "UNT-003": {
//     tenantName: "C-Tenant 3",
//     propertyName: "Property C",
//     unitName: "C-103",
//     monthlyRent: "UGX 250000",
//     deposit: "UGX 250000",
//     paidThrough: "May 30, 2025",
//     outstanding: "None",
//     phone: "0700345678",
//     status: "Vacant",
//     payments: [
//       {
//         date: "May 12, 2025",
//         amount: "UGX 250000",
//         coveredFrom: "May 17, 2025",
//         coveredTo: "Jun 16, 2025",
//       },
//     ],
//   },
//   "UNT-004": {
//     tenantName: "D-Tenant 4",
//     propertyName: "Property D",
//     unitName: "D-104",
//     monthlyRent: "UGX 190000",
//     deposit: "UGX 190000",
//     paidThrough: "May 20, 2025",
//     outstanding: "None",
//     phone: "0700456789",
//     status: "Occupied",
//     payments: [
//       {
//         date: "May 05, 2025",
//         amount: "UGX 190000",
//         coveredFrom: "May 10, 2025",
//         coveredTo: "Jun 09, 2025",
//       },
//       {
//         date: "Apr 05, 2025",
//         amount: "UGX 190000",
//         coveredFrom: "Apr 10, 2025",
//         coveredTo: "May 09, 2025",
//       },
//       {
//         date: "Mar 05, 2025",
//         amount: "UGX 190000",
//         coveredFrom: "Mar 10, 2025",
//         coveredTo: "Apr 09, 2025",
//       },
//       {
//         date: "Feb 05, 2025",
//         amount: "UGX 190000",
//         coveredFrom: "Feb 10, 2025",
//         coveredTo: "Mar 09, 2025",
//       },
//       {
//         date: "Jan 05, 2025",
//         amount: "UGX 190000",
//         coveredFrom: "Jan 10, 2025",
//         coveredTo: "Feb 09, 2025",
//       },
//       {
//         date: "Dec 05, 2024",
//         amount: "UGX 190000",
//         coveredFrom: "Dec 10, 2024",
//         coveredTo: "Jan 09, 2025",
//       },
//       {
//         date: "Nov 05, 2024",
//         amount: "UGX 190000",
//         coveredFrom: "Nov 10, 2024",
//         coveredTo: "Dec 09, 2024",
//       },
//       {
//         date: "Oct 05, 2024",
//         amount: "UGX 190000",
//         coveredFrom: "Oct 10, 2024",
//         coveredTo: "Nov 09, 2024",
//       },
//       {
//         date: "Sep 05, 2024",
//         amount: "UGX 190000",
//         coveredFrom: "Sep 10, 2024",
//         coveredTo: "Oct 09, 2024",
//       },
//       {
//         date: "Aug 05, 2024",
//         amount: "UGX 190000",
//         coveredFrom: "Aug 10, 2024",
//         coveredTo: "Sep 09, 2024",
//       },
//     ]
//   },
//   "UNT-005": {
//     tenantName: "E-Tenant 5",
//     propertyName: "Property E",
//     unitName: "E-105",
//     monthlyRent: "UGX 260000",
//     deposit: "UGX 260000",
//     paidThrough: "May 18, 2025",
//     outstanding: "None",
//     phone: "0700567890",
//     status: "Vacant",
//     payments: [
//       {
//         date: "May 01, 2025",
//         amount: "UGX 260000",
//         coveredFrom: "May 06, 2025",
//         coveredTo: "Jun 05, 2025",
//       },
//     ],
//   },
//   "UNT-006": {
//     tenantName: "F-Tenant 6",
//     propertyName: "Property F",
//     unitName: "F-106",
//     monthlyRent: "UGX 220000",
//     deposit: "UGX 220000",
//     paidThrough: "May 26, 2025",
//     outstanding: "None",
//     phone: "0700678901",
//     status: "Occupied",
//     payments: [
//       {
//         date: "May 11, 2025",
//         amount: "UGX 220000",
//         coveredFrom: "May 16, 2025",
//         coveredTo: "Jun 15, 2025",
//       },
//     ],
//   },
//   "UNT-007": {
//     tenantName: "G-Tenant 7",
//     propertyName: "Property G",
//     unitName: "G-107",
//     monthlyRent: "UGX 200000",
//     deposit: "UGX 200000",
//     paidThrough: "May 24, 2025",
//     outstanding: "None",
//     phone: "0700789012",
//     status: "Vacant",
//     payments: [
//       {
//         date: "May 09, 2025",
//         amount: "UGX 200000",
//         coveredFrom: "May 14, 2025",
//         coveredTo: "Jun 13, 2025",
//       },
//     ],
//   },
//   "UNT-008": {
//     tenantName: "H-Tenant 8",
//     propertyName: "Property H",
//     unitName: "H-108",
//     monthlyRent: "UGX 240000",
//     deposit: "UGX 240000",
//     paidThrough: "May 29, 2025",
//     outstanding: "None",
//     phone: "0700890123",
//     status: "Occupied",
//     payments: [
//       {
//         date: "May 14, 2025",
//         amount: "UGX 240000",
//         coveredFrom: "May 19, 2025",
//         coveredTo: "Jun 18, 2025",
//       },
//     ],
//   },
//   "UNT-009": {
//     tenantName: "I-Tenant 9",
//     propertyName: "Property I",
//     unitName: "I-109",
//     monthlyRent: "UGX 270000",
//     deposit: "UGX 270000",
//     paidThrough: "May 27, 2025",
//     outstanding: "None",
//     phone: "0700901234",
//     status: "Occupied",
//     payments: [
//       {
//         date: "May 13, 2025",
//         amount: "UGX 270000",
//         coveredFrom: "May 18, 2025",
//         coveredTo: "Jun 17, 2025",
//       },
//     ],
//   },
//   "UNT-010": {
//     tenantName: "J-Tenant 10",
//     propertyName: "Property J",
//     unitName: "J-110",
//     monthlyRent: "UGX 280000",
//     deposit: "UGX 280000",
//     paidThrough: "May 31, 2025",
//     outstanding: "None",
//     phone: "0701012345",
//     status: "Vacant",
//     payments: [
//       {
//         date: "May 15, 2025",
//         amount: "UGX 280000",
//         coveredFrom: "May 20, 2025",
//         coveredTo: "Jun 19, 2025",
//       },
//     ],
//   },
// };


const LandLordTable = () => {
//   const navigate = useNavigate();

//   const handleViewPaymentsClick = (unitId) => {
//     navigate(`/landlords/payments/${unitId}`);
//   };

//   const handleEditTenant = (unitId) => {
//   navigate(`/landlords/add-tenant/${unitId}`);
// };

//   const units = Object.entries(PropertyUnits).map(([id, info]) => ({
//     key: id,
//     id,
//     unitName: info.unitName,
//     deposit: info.deposit,
//     rent: info.monthlyRent,
//     occupied: !!info.tenantName,
//     tenantName: info.tenantName,
//     phone: info.phone || "N/A",
//     status: info.status || "Pending",
//     payments: info.payments,
//   }));

//   const nestedColumns = [
//     {
//       title: (<span className="text-[#4772F1] font-bold font-inter text-[8px] sm:text-[10px] md:text-[12px] lg:text-[14px]">Tenant Name</span>),
//       dataIndex: "tenantName",
//       key: "tenantName",
//       responsive: ["sm"],
//     },
//     {
//       title: (<span className="text-[#4772F1] font-bold font-inter text-[8px] sm:text-[10px] md:text-[12px] lg:text-[14px]">Phone Number</span>),
//       dataIndex: "phone",
//       key: "phone",
//       responsive: ["sm"],
//     },
//     {
//       title: (<span className="text-[#4772F1] font-bold font-inter text-[8px] sm:text-[10px] md:text-[12px] lg:text-[14px]">Status</span>),
//       dataIndex: "status",
//       key: "status",
//       responsive: ["sm"],
//       render: (text) => (
//         <Tag
//           className="rounded-[15px] px-3 py-[2px] font-inter text-[9px] sm:text-[10px] md:text-[11px] lg:text-[12px] leading-[20px]"
//           color={text === "Occupied" ? "green" : "orange"}
//         >
//           {text}
//         </Tag>
//       ),
//     },
//     {
//       title: "",
//       key: "mobileView",
//       responsive: ["xs"],
//       render: (record) => (
//         <div className="flex flex-col gap-1 ml-12 relative -top-0 bg-white   text-[#4772F1] font-bold font-inter text-[11px] sm:text-[13px]">
//           <div><b>Name:</b><span className="text-[#707070] font-inter text-[10px] md:text-[12px] lg:text-[14px] font-normal px-2 py-2 whitespace-normal break-words"> {record.tenantName}</span></div>
//           <div><b>Phone:</b><span className="text-[#707070] font-inter text-[10px] md:text-[12px] lg:text-[14px] font-normal px-2 py-2 whitespace-normal break-words">{record.phone}</span></div>
//           <div>
//             <b>Status:</b>{" "}
//             <Tag 
//             color={record.status === "Occupied" ? "green" : "orange"}>
//               <span className="rounded-[15px] px-3 py-[2px] font-inter text-[9px] sm:text-[10px] md:text-[11px] lg:text-[12px] leading-[20px]">{record.status}</span>
//             </Tag>
//           </div>
//         </div>
//       ),
//     },
//   ];

//   const columns = [
//     { title: "Unit ID", dataIndex: "id", key: "id", responsive: ["sm"], },
//     { title: "Unit Name", dataIndex: "unitName", key: "unitName", responsive: ["sm"], },
//     { title: "Deposit", dataIndex: "deposit", key: "deposit", responsive: ["sm"], },
//     { title: "Monthly Rent", dataIndex: "rent", key: "rent", responsive: ["sm"], },
//     {
//       title: "Actions",
//       key: "actions",
//       responsive: ["sm"],
//       render: (_, record) => (
//         <div className="flex justify-center gap-2 flex- sm:justify-start">
//           <Button
//             size="small"
//             icon={<EditOutlined />}
//             className="text-[#C46500] border-[#C46500] w-[49px] lg:w-[69px] h-7 flex items-center justify-center text-center rounded-[15px] font-normal leading-6 tracking-[0%] text-[9px] sm:text-[10px] md:text:[11px] lg:text-[12px] font-inter"
//           >
//             Edit
//           </Button>

//           <Button
//             size="small"
//             icon={record.status === "Occupied" ? <EditOutlined /> : <UserAddOutlined />}
//             onClick={() => {
//               handleEditTenant(record.id)
//             }}
//             className={` rounded-[15px] font-normal w-[92px] lg:w-[112px] h-7 leading-6 tracking-[0%] text-[9px] sm:text-[10px] md:text-[11px] lg:text-[12px] font-inter flex items-center justify-center ${
//               record.status === "Occupied"
//                 ? "text-[#873FE2] border-[#873FE2]"
//                 : "text-[#07C01D] border-[#07C01D]"
//             }`}
//           >
//             {record.status === "Occupied" ? "Edit Tenant" : "Add Tenant"}
//           </Button>
//           <Button
//             size="small"
//             icon={<WalletOutlined />}
//             onClick={() => handleViewPaymentsClick(record.id)}
//             className="text-[#0000FF] border-[#0000FF] w-[110px] lg:w-[130px] h-7 rounded-[15px] font-normal leading-6 tracking-[0%] text-[9px] sm:text-[10px] md:text:[11px] lg:text-[12px] font-inter flex items-center justify-center text-center"
//           >
//             View Payments
//           </Button>
//         </div>
//       ),
//     },
//     {
//       title: "",
//       key: "mobileView",
//       responsive: ["xs"],
//       render: (record) => (
//         <div className="flex flex-col gap-1  font-inter  text-[#4772F1] font-semibold   text-[12px] px-3 py-2">
//           <div><b>Unit ID:</b> <span className="text-[#707070] font-sans leading-5 text-[12px] lg:text-[14px] font-[400] tracking-[0%]  px-4 py-2">{record.id}</span></div>
//           <div><b>Unit Name:</b> <span className="text-[#707070] font-sans leading-5 text-[12px] lg:text-[14px] font-[400] tracking-[0%]  px-4 py-2">{record.unitName}</span></div>
//           <div><b>Deposit:</b> <span className="text-[#707070] font-sans leading-5 text-[12px] lg:text-[14px] font-[400] tracking-[0%]  px-4 py-2">{record.deposit}</span></div>
//           <div><b>Rent:</b><span className="text-[#707070] font-sans leading-5 text-[12px] lg:text-[14px] font-[400] tracking-[0%]  px-4 py-2"> {record.rent}</span></div>
//           <div className="flex flex-wrap gap-2 mt-2">
//             <Button size="small" icon={<EditOutlined />} className="text-[#C46500] border-[#C46500] rounded-[15px] h-7 text-[12px] font-inter">Edit</Button>
//             <Button
//               size="small"
//               icon={record.status === "Occupied" ? <EditOutlined /> : <UserAddOutlined />}
//               onClick={() => {
//                 handleEditTenant(record.id)
//               }}
//               className={`rounded-[15px] h-7 text-[12px] font-inter ${
//                 record.status === "Occupied" ? "text-[#873FE2] border-[#873FE2]" : "text-[#07C01D] border-[#07C01D]"
//               }`}
//             >
//               {record.status === "Occupied" ? "Edit Tenant" : "Add Tenant"}
//             </Button>
//             <Button size="small" icon={<WalletOutlined />} className="text-[#0000FF] border-[#0000FF] rounded-[15px] h-7 text-[12px] font-inter">
//               View Payments
//             </Button>
//           </div>
//         </div>
//       ),
//     },
//   ];

  return (
    // <div className="min-h-screen bg-diagonal-sky w-full lg:w-[1080px] xl:w-full p-[0px]">
    //     <div className="overflow-x-auto">
    //     <Table
    //       columns={columns}
    //       dataSource={units}
    //       expandable={{
    //         expandedRowRender: (record) => (
    //           <Table
    //             columns={nestedColumns}
    //             dataSource={[record]}
    //             pagination={false}
    //             size="small"
    //           rowKey={(item) => `${record.id}-${item.date}`}
    //           components={{
    //             body: {
    //               cell: (props) => (
    //                 <td
    //                   {...props}
    //                   className="text-[#707070] font-inter text-[8px] sm:text-[10px] md:text-[12px] lg:text-[14px] font-normal px-2 py-2 whitespace-normal break-words"
    //                 >
    //                   {props.children}
    //                 </td>
    //               ),
    //             },
    //           }}
    //           />
    //         ),
    //         rowExpandable: () => true,
    //       rowExpandable: (record) => record.payments.length > 0,
    //         expandIcon: ({ expanded, onExpand, record }) => (
    //           <div
    //             onClick={(e) => onExpand(record, e)}
    //             className="w-3 h-3 md:w-[16px] md:h-[16px] lg:w-[20px] lg:h-[20px] flex items-center justify-center border border-[#4772F1] rounded-[4px] cursor-pointer hover:shadow-md transition-all bg-white"
    //           >
    //             <span className="text-[#757575] text-[10px] sm:text-[14px]  md:text-[18px] lg:text-[24px] flex items-center justify-center sm:pb-1  select-none ">
    //               {expanded ? "-" : "+"}
    //             </span>
    //           </div>
    //         ),
    //       }}
    //       pagination={false}
    //       bordered={false}
    //       components={{
    //         header: {
    //           cell: (props) => (
    //             <th
    //               {...props}
    //               className={`text-[#4772F1] font-bold font-inter h-[46px] text-[8px] sm:text-[10px] md:text-[12px] lg:text-[14px] px-3 py-2`}
    //               style={{
    //                 background:
    //                   "linear-gradient(180deg, rgba(229, 240, 255, 0.1764) -2.17%, rgba(135, 63, 226, 0.0784) 100%)",
    //                 fontWeight: 700,
    //                 color: "#4772F1",
    //                 height: "46px",
    //                 borderTopLeftRadius:
    //                   props["data-index"] === "id" ? "8px" : 0,
    //                 borderTopRightRadius:
    //                   props["data-index"] === "actions" ? "8px" : 0,
    //                 ...props.style,
    //               }}
    //             />
    //           ),
    //         },
    //         body: {
    //           cell: (props) => (
    //             <td
    //               {...props}
    //               className="text-[#707070] font-sans leading-5 text-[8px] sm:text-[10px] md:text-[12px] lg:text-[14px] font-[400] tracking-[0%]  px-4 py-2"
    //             >
    //               {props.children}
    //             </td>
    //           ),
    //         },
    //       }}
    //     />
    //   </div>
    // </div>
    <div></div>
  );
};

export default LandLordTable;